module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "onboarding-box",
    staticClass: "row no-margin start-xs"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_onboarding),
      expression: "show_onboarding"
    }],
    staticClass: "onboarding",
    class: _vm.step_to_show.classes
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.step_to_show.description)
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "capitalize"
  }, [_vm._v("\n      " + _vm._s(_vm.step_to_show.domID === 'onboarding-class-dropdown' ?
    _vm.getCourseDetail.title :
    null) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ok-button end-xs",
    staticStyle: {
      "font-weight": "bolder"
    },
    on: {
      "click": function($event) {
        return _vm.changeStep(_vm.step_to_show)
      }
    }
  }, [_vm._v("\n      OK\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-f569c1c4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onboarding/onboardingSteps.vue
// module id = 985
// module chunks = 61